import styles from './styles/EditorialBadges.css'
import classNames from 'classnames'
import { cleanStatus, groupSimilarNotices } from './EditorialNotices'
import Badge from './Badge'

const EditorialBadges = ({ notices }) => {
  return (
    <span className={styles.layout}>
      {groupSimilarNotices(notices)?.map(({ date, noticeDoi, status, doi }, i) => (
        <a key={i} target='_blank' rel='noopener noreferrer' href={(noticeDoi || doi) && `https://doi.org/${noticeDoi || doi}`}>
          <Badge className={classNames({
            [styles.withdrawn]: status === 'removed',
            [styles.retracted]: status === 'Retracted',
            [styles.withdrawn]: status === 'Withdrawn',
            [styles.correction]: status === 'Has correction',
            [styles.erratum]: status === 'Has erratum',
            [styles.concern]: status === 'Has expression of concern'
          })}
          >
            {cleanStatus(status)} {date && (`${date}`)}
          </Badge>
        </a>
      ))}
    </span>
  )
}

export default EditorialBadges
